import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../../zodios/client";

export function useCommitPricingPlanUpload(uploadId: number | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ ignoreWarnings }: { ignoreWarnings: boolean }) =>
      await apiClient.processUpload({ ignoreWarnings }, { params: { id: uploadId! } }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [{ entity: "uploads", scope: "detail", id: uploadId }] });
    },
  });
}
